import React from "react"

class MapBoxErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <p>Map couldn’t be loaded. Your browser or device may not support map rendering.</p>;
    }
    return this.props.children;
  }
}

export default MapBoxErrorBoundary